import './style.module.scss'

import { BackgroundColor } from '@ampcore/ampcom-contracts'
import React from 'react'
import xss from 'xss'

import { CertificateRatesItemColor } from './CertificateRatesItemColor.type'

type RatesCompoundItem = {
  ratesContent?: string
  bgColor?: CertificateRatesItemColor
  isRateLast?: boolean
}

export type CertificateRatesProps = {
  heading?: string
  ratesCompound?: RatesCompoundItem[]
  disclaimer?: string
  hasVerticalDivider?: boolean
  testId?: string
}

export const CertificateRates = (props: CertificateRatesProps) => {
  const { heading, ratesCompound, disclaimer, hasVerticalDivider, testId } =
    props

  const rates = ratesCompound ?? []

  function getRatesBackgroundColor(bgColor?: BackgroundColor) {
    switch (bgColor) {
      case BackgroundColor.AMERIPRISE_BLUE:
        return 'u-bgColorAmpfBlue'
      case BackgroundColor.PURPLE:
        return 'u-bgColorPurple'
      case BackgroundColor.BERRY:
        return 'u-bgColorBerry'
      case BackgroundColor.DARK_MINT:
        return 'u-bgColorDarkMint'
      default:
        return ''
    }
  }

  return (
    <div className="CertificateRates u-sm-flexCol" data-testid={testId}>
      <div
        className={`CertificateRates-rates u-sm-sizeFull u-borderRadius24${
          hasVerticalDivider
            ? ' u-borderLeft u-paddingLeft20 u-sm-borderTop u-sm-borderLeft0 u-sm-paddingTop32 u-sm-paddingLeft0'
            : ''
        }`}
      >
        {heading && (
          <div
            className="CertificateRates-rateHeading Content u-paddingBottom24"
            data-testid={testId ? `${testId}-heading` : undefined}
            dangerouslySetInnerHTML={{
              __html: xss(heading)
            }}
          />
        )}
        <div className="CertificateRates-ratesRow">
          {rates.map((rate, rateIndex) => (
            <div
              key={rateIndex}
              className="CertificateRates-rate"
              data-testid={testId ? `${testId}-rate-${rateIndex}` : undefined}
            >
              <div
                className={`CertificateRates-rateContent Content--reversed ${getRatesBackgroundColor(rate.bgColor)} u-flex u-flexJustifyCenter u-flexAlignItemsCenter`}
                data-testid={
                  testId ? `${testId}-rateContent-${rateIndex}` : undefined
                }
              >
                {rate.ratesContent && (
                  <div
                    className="CertificateRates-rateData"
                    dangerouslySetInnerHTML={{
                      __html: xss(rate.ratesContent)
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        {disclaimer && (
          <div
            className="CertificateRates-rateDisclaimer Content u-paddingTop32"
            data-testid={testId ? `${testId}-disclaimer` : undefined}
            dangerouslySetInnerHTML={{
              __html: xss(disclaimer)
            }}
          />
        )}
      </div>
    </div>
  )
}
